var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3984 10.7695C20.7498 10.418 21.3197 10.418 21.6712 10.7695L26.2649 15.3632C26.6164 15.7147 26.6164 16.2845 26.2649 16.636L21.6712 21.2298C21.3197 21.5812 20.7498 21.5812 20.3984 21.2298C20.0469 20.8783 20.0469 20.3084 20.3984 19.957L24.3557 15.9996L20.3984 12.0423C20.0469 11.6908 20.0469 11.1209 20.3984 10.7695Z",
    fill: "#CE4848"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4746 15.9996C12.4746 15.5026 12.8776 15.0996 13.3746 15.0996H25.6246C26.1217 15.0996 26.5246 15.5026 26.5246 15.9996C26.5246 16.4967 26.1217 16.8996 25.6246 16.8996H13.3746C12.8776 16.8996 12.4746 16.4967 12.4746 15.9996Z",
    fill: "#CE4848"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.27461 7.27461H15.1246C15.6217 7.27461 16.0246 6.87167 16.0246 6.37461C16.0246 5.87755 15.6217 5.47461 15.1246 5.47461H7.24961C6.77885 5.47461 6.32737 5.66162 5.9945 5.9945C5.66162 6.32737 5.47461 6.77885 5.47461 7.24961V24.7496C5.47461 25.2204 5.66162 25.6718 5.9945 26.0047C6.32737 26.3376 6.77885 26.5246 7.24961 26.5246H15.1246C15.6217 26.5246 16.0246 26.1217 16.0246 25.6246C16.0246 25.1276 15.6217 24.7246 15.1246 24.7246H7.27461V7.27461Z",
    fill: "#CE4848"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.2db8ceaf5f7a91c92d859fb36a20a2da.svg";
export { ForwardRef as ReactComponent };